// FOR ALL WIDGETS PROPS RELATED CONSTANTS 

// IMAGE/VIDEO PICKER CONSTANTS ::::

export const IMGVIDPICKER_CONSTANTS = {
  IMAGE: {
    TOGGLES: [
      { formControlName: 'Compression', label: 'Image Compression' },
      { formControlName: 'GalleryUpload', label: 'Gallery Upload' },
      { formControlName: 'GeoReference', label: 'Geo Reference' },
    ],
    FORMATS: [
      { key: 'JPEG', value: 'JPEG' },
      { key: 'PNG', value: 'PNG' },
      { key: 'GIF', value: 'GIF' },
      { key: 'JPG', value: 'JPG' },
    ],
    CONFIGS : ['allowedTypes', 'maxSize', 'Compression', 'GalleryUpload', 'GeoReference', 'baringToggle', 'gpsAccuracy']
  },
  VIDEO: {
    TOGGLES: [
      { formControlName: 'Compression', label: 'Video Compression' },
      { formControlName: 'GalleryUpload', label: 'Gallery Upload' },
      { formControlName: 'GeoReference', label: 'Geo Reference' },
    ],
    FORMATS: [
      { key: 'MOV', value: 'MOV' },
      { key: 'MP4', value: 'MP4' },
      { key: 'AVI', value: 'AVI' },
      { key: 'MKV', value: 'MKV' },
    ],
    CONFIGS: ['allowedTypes', 'maxSize', 'Compression','GalleryUpload','GeoReference',  'baringToggle', 'gpsAccuracy'],
  },
  DOCUMENT: {
    CONFIGS : ['']
  },
  IMGDIRECTION : {
    CONFIGS : ['']
  }
};

// DATERANGE PICKER CONSTANTS ::::::

export const DATERANGE_CONSTANTS = {
  DATE_FORMATS: [
    { label: 'dd/MM/yyyy', value: 'dd/MM/yyyy' },
    { label: 'yyyy/MM/dd', value: 'yyyy/MM/dd' },
    { label: 'dd/MM/yyyy HH:mm:ss', value: 'dd/MM/yyyy HH:mm:ss' },
    { label: 'yyyy/MM/dd HH:mm:ss', value: 'yyyy/MM/dd HH:mm:ss' },
  ],
  TOGGLES: [
    { formControlName: 'dateRangeEnable', label: 'Date Range' },
  ],
};

// FILEUPLOADER CONSTANTS :::::::
export const FILEUPLOADER_CONSTANTS = {
  FILE_FORMATS : [
    { key: 'PDF', value: "PDF" },
    { key: 'DOC', value: "DOC" },
    { key: 'DOCX', value: "DOCX" },
    { key: 'XLS', value: "XLS" },
    { key: 'XLSX', value: "XLSX" },
    { key: 'TEXT', value: "TEXT" },
  ],
  TOGGLES: [
    { formControlName: 'fileCompression', label: 'File Compression' },
  ],
}

export const MAT_UI_TYPES = {
  outlined:'outlined',
  filled:'filled'
}

//Accuracies
export const ACCURACIES_CONSTANTS : {accuracy:string,range:string}[] = [
  {accuracy:'High',range:'10-20'},
  {accuracy:'Medium',range:'21-30'},
  {accuracy:'Low',range:'31-40'}
]

export const DATABOARDHEADERTYPES  = {
  generic:'generic',
  custom:'custom header'
}